import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomTitle, LocalService } from 'lib-base';
import { DialogModule } from 'primeng/dialog';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'app-alertas-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, CustomTitle],
  template: `
  <section>
    <p-dialog [(visible)]="display" [modal]="true" [autoZIndex]="true" [draggable]="false" [resizable]="true"
      [maximizable]="true" [breakpoints]="{'640px': '100vw'}" [style]="{width: '50vw'}">

      <ng-template pTemplate="header">
        <CustomTitle [title]="headerTitle" />
      </ng-template>

      <ng-template pTemplate="content">        
        <ul>
          <li *ngFor="let item of data">
            {{ item }}
          </li>
        </ul>                
      </ng-template>

      <ng-template pTemplate="footer">      
      </ng-template>
    </p-dialog>
  </section>
  `
})
export class AlertasDialogComponent implements OnInit{

  @Input() headerTitle: string = '';
  display: boolean = false;
  data: String[] = [];

  trans: any = {};

  constructor(private readonly _t: TranslateService) {
  }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      noHayAlertasParaMostrar: this._t.get('msg.noHayAlertasParaMostrar'),
    }));
  }

  show(data: String[]): void {
    if (!data || data.length === 0) {
      data.push(this.trans.noHayAlertasParaMostrar);
    }
    this.data = data;
    this.display = true;
  }

  hide(): void {
    this.display = false;
  }
}
